<template>
  <div class="success">
    <div class="text">提交成功!</div>
    <div class="wait">您的支付凭证已提交, 请等待工作人员审核。</div>
    <div class="query">保函申请进度及发票查询：13993648503</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped="scoped">
.success {
  width: 1200px;
  margin: 0 auto;
  height: calc(60vh - 91px);
  min-height: 500px;
  max-height: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text {
    color: #00dd62;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .wait {
    font-size: 40px;
    color: rgb(41, 41, 41);
    font-weight: bold;
  }
  .query{
    font-size: 30px;
    color: #999;
    font-weight: bold;
  }
}
</style>
